import React, { useState, useEffect } from "react";
import { Modal, Input, Select, Button } from "antd"; // Import Ant Design components
import api from "./../../../../api.js";
import "./flatdetails.css";
import Dashheader from "../../Dashheader/Dashheader";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../../utilis/Loading.js";
import { useToasts } from "react-toast-notifications";
import utilis from "../../../../utilis";
import { useParams } from "react-router-dom";

const Flatdetails = () => {
   const { addToast } = useToasts();
  const [loading, setLoading] = useState(true);
  const [flatDetails, setFlatDetails] = useState([]);
  const [error, setError] = useState(null);
  const [selectedFlat, setSelectedFlat] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [isEstimationModalOpen, setIsEstimationModalOpen] = useState(false); // New state for estimation form

  const location = useLocation();
  const towerId = location.state?.towerId || localStorage.getItem("selectedTowerId");
  const storedData = JSON.parse(localStorage.getItem("AdminDetails")) || {};
  let managementId = storedData?.data?.data?._id || null;
  const [formData, setFormData] = useState({
    name: "",
    towerName: "",
    towerId: towerId || "",
    phone: '',
    countryCode: "+91",
    emailId: "",
    address: "",
    pinCode: '',
    flatNo: "",
    blockNo: "",
    bedrooms: "", 
    sqFeet: "",
    sqPrice: "",
    finalSqPrice: "",  // ✅ Add this line
    unitType: "",
    specialFeaturePrice: "",
    specialFeature: "",
     parkingCharges: 0,
  parkingSlot: "NA",
    totalAmount: "",
    remarks: "",
    createdBy:managementId,
  });

 const GetFlatDetails = async () => {
  if (!towerId) {
    setError("No Tower ID found.");
    setLoading(false);
    return;
  }

  setLoading(true);
  try {
    let response = await api.getAllFlatsDetailsForBooking(towerId);
    let allFlats = response.data.data;
    console.log(response.data.data, 'allflatdetails');
    
    if(response.status === 401){
      console.log("Session Expired! Redirecting to Login.");
      localStorage.removeItem(utilis.string.localStorage.sessionId);
      localStorage.removeItem(utilis.string.localStorage.userData);
      navigate('/');
    }
    
    let filteredFlats = allFlats.filter((flat) => String(flat.towerId) === String(towerId));
    
    // ✅ SORT: Numbered flats first, then G series at the bottom
    filteredFlats.sort((a, b) => {
      const flatNoA = a.flatNo;
      const flatNoB = b.flatNo;
      
      // Check if flatNo starts with 'G'
      const isGA = flatNoA.toString().startsWith('G');
      const isGB = flatNoB.toString().startsWith('G');
      
      // If one is G series and other is not, G series goes to bottom
      if (isGA && !isGB) return 1;
      if (!isGA && isGB) return -1;
      
      // If both are G series, sort them naturally (G1, G2, G3...)
      if (isGA && isGB) {
        const numA = parseInt(flatNoA.replace('G', '')) || 0;
        const numB = parseInt(flatNoB.replace('G', '')) || 0;
        return numA - numB;
      }
      
      // If both are numbered flats, sort numerically
      return parseInt(flatNoA) - parseInt(flatNoB);
    });

    setFlatDetails(filteredFlats.length > 0 ? filteredFlats : allFlats);
  } catch (error) {
    console.error("Error fetching flat details:", error);
    setError("Failed to load flat details. Please try again.");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    GetFlatDetails();
  }, []);

  const openModal = (flat) => {
    setSelectedFlat(flat);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedFlat(null);
  };

 const openEstimationModal = () => {
  if (selectedFlat) {
    const sqFeet = parseFloat(selectedFlat.sqFeet) || 0;
    const sqPrice = parseFloat(selectedFlat.sqPrice) || 0;
    const specialFeaturePrice = parseFloat(selectedFlat.specialFeaturePrice) || 0;
    const intrestRate = parseFloat(selectedFlat.intrestRate) || 0;
    
    const A = sqFeet * sqPrice;
    const B = A + specialFeaturePrice;
    const totalAmount = B + (B * (intrestRate / 100));
    
    setFormData({
      ...formData,
      towerName: selectedFlat.name || "",
      towerId: selectedFlat.towerId || towerId || "",
      flatNo: selectedFlat.flatNo || "",
      blockNo: selectedFlat.blockName || "",
      bedrooms: selectedFlat.bedrooms || "", 
      sqFeet: selectedFlat.sqFeet || "",
      sqPrice: selectedFlat.sqPrice || "",
      finalSqPrice: selectedFlat.sqPrice || "",  // ✅ ADD THIS LINE - Initialize with sqPrice
      unitType: selectedFlat.unitType || "",
      specialFeaturePrice: selectedFlat.specialFeaturePrice || "",
      specialFeature: selectedFlat.specialFeature || "",
      totalAmount: totalAmount || 0,
    });
  }
  setIsEstimationModalOpen(true);
};

  

  const [showPaymentCalculation, setShowPaymentCalculation] = useState(false);


 const closeEstimationModal = () => {
  setIsEstimationModalOpen(false);
  setShowPaymentCalculation(false); // Reset payment calculation display
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


 

  const [emiplans, setEmiplans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Fetch EMI plans from API
  const Getemiplans = async () => {
    try {
      let response = await api.getAllEmiPlans();
      setEmiplans(response.data.data);
    } catch (error) {
      console.error("Error fetching EMI plans:", error);
    }
  };

  useEffect(() => {
    Getemiplans();
  }, []);


  const { Option } = Select;
// Handle Installment Type selection
const handleSelectChange = (value) => {
  // Find the selected EMI plan
  const plan = emiplans.find((p) => p._id === value);
  setSelectedPlan(plan);

  // Recalculate totalAmount based on the interest rate of the selected plan
  if (plan) {
    const sqFeet = parseFloat(formData.sqFeet) || 0;
    const sqPrice = parseFloat(formData.sqPrice) || 0;
    const specialFeaturePrice = parseFloat(formData.specialFeaturePrice) || 0;
    
    // Calculate A (sqFeet * sqPrice)
    const A = sqFeet * sqPrice;
    
    // Calculate B (A + specialFeaturePrice)
    const B = A + specialFeaturePrice;
    
    // Recalculate totalAmount (B + (B * interestRate / 100))
    const totalAmount = B + (B * (plan.intrestRate / 100)); 

    // Update formData with new interest rate and calculated totalAmount
    setFormData({
      ...formData,
      installmentType: plan.name || "",
      intrestRate: plan.intrestRate || 0,
      totalAmount: totalAmount || 0,
      
    });
  }
};

const handleSubmit = async (e) => {  // ✅ Add 'async' here
  e.preventDefault();

  console.log("Form Data before submit: ", formData);

  try {
    const response = await api.createEstimationForm(formData);  // ✅ 'await' works inside 'async'
    if(response.status === 401){
      console.log("Session Expired! Redirecting to Login.");
      localStorage.removeItem(utilis.string.localStorage.sessionId);
      localStorage.removeItem(utilis.string.localStorage.userData);
      navigate('/');
    }

    if (response.status === 200) {
     

      addToast("create estimation sent successfully", {
        appearance: "success",
        autoDismiss: true,
      });
      setIsEstimationModalOpen(false)
          // Reset form data
  setFormData({
    name: "",
    towerName: "",
    towerId: towerId || "",
    phone: '',
    countryCode: "+91",
    emailId: "",
    address: "",
    pinCode: '',
    flatNo: "",
    blockNo: "",
    bedrooms: "", // Add this line
    sqFeet: "",
    sqPrice: "",
    unitType: "",
    specialFeaturePrice: "",
    specialFeature: "",
    totalAmount: "",
      parkingCharges: 0,        // Add this
  parkingSlot: "NA",   // Add this
    remarks: "",
    createdBy:managementId,
  });

  // Optional: Reset selected plan if needed
  setSelectedPlan(null);


    } else {
      addToast(response.data?.message || "Something went wrong!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  } catch (error) {
  
    console.error('Error:', error);
  } 
};

let navigate=useNavigate()
  const handleBookFlat=()=>{
    const towerId = localStorage.getItem("selectedTowerId") || "";
    const flatId = selectedFlat?.flatId || ""; // Retrieve the flatId from the selected flat
    console.log("Selected flatId:", flatId);
  console.log("Retrieved towerId from localStorage:", towerId);
 
    navigate('/dashboard/bookingflats', { state: { towerId,flatId} })
  }

   const { flatId, parkingCharges } = useParams();
  const [PaymentCalculation, setPaymentCalculation] = useState(null);

 const GetPaymentCalculation = async (flatId, parkingCharges) => {
  try {
    // ✅ Use the same logic as UI display - send what user sees
    const finalSqPrice = formData.finalSqPrice || formData.sqPrice;
    
    console.log("Sending to API - finalSqPrice:", finalSqPrice); // Debug log
    
    let response = await api.getPaymentCalculation(flatId, parkingCharges, finalSqPrice);
    setPaymentCalculation(response.data.data);
    console.log("Fetched PaymentCalculation:", response.data.data);
  } catch (error) {
    console.error("Error PaymentCalculation:", error);
  }
};


  useEffect(() => {
    if (flatId) {
      GetPaymentCalculation(flatId, parkingCharges || 0); // dynamic values
    }
  }, [flatId, parkingCharges]);


const handleCheckEstimation = async () => {
  try {
    const flatId = selectedFlat?.flatId;
    
    if (!flatId) {
      addToast("Flat ID not found", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    console.log("Sending flatId:", flatId, "parkingCharges:", formData.parkingCharges);
    
    // Call your existing GetPaymentCalculation function
    await GetPaymentCalculation(flatId, formData.parkingCharges);
    
    // Show the payment calculation section
    setShowPaymentCalculation(true);
    
    addToast("Estimation calculated successfully", {
      appearance: "success",
      autoDismiss: true,
    });
    
  } catch (error) {
    console.error('Error calculating estimation:', error);
    addToast("Failed to calculate estimation", {
      appearance: "error",
      autoDismiss: true,
    });
  }
};





  return (
    <>
      <Dashheader />
      <div className="flat-details-container">
        <h2 className="flat-details-title">Flat Details</h2>

        {loading ? (
          <Loading />
        ) : error ? (
          <p className="error-message">{error}</p>
        ) : flatDetails.length > 0 ? (
          <>
            <div className="flat-buttons-container">
         {flatDetails.map((flat) => (
  <button
    key={flat._id}
    className={`flat-button ${
      flat.isAvaliable === "AVALIABLE" 
        ? "available" 
        : flat.isAvaliable === "ONHOLD" 
        ? "onhold" 
        : "not-available"
    }`}
    onClick={() => openModal(flat)}
    disabled={flat.isAvaliable === "BOOKED"} // Only disable booked flats
  >
    {flat.flatNo}-({flat.bedrooms})
    <br />
    <div className="blockname">
      Block- {flat.blockName?.toUpperCase()}
    </div>
  </button>
))}

            </div>

            {/* Flat Details Modal */}
           
{/* Flat Details Modal */}
<Modal
  title={`${selectedFlat?.projectName} - FLAT NO: ${selectedFlat?.flatNo}`}
  open={isModalOpen}
  onCancel={closeModal}
  footer={null}
  width={600}
>
  {selectedFlat && (
    <div className="flat-card">
      <div className="flat-card-body">
        {/* <p><strong>Price&nbsp;:&nbsp; </strong> {selectedFlat.priceStartRange?.toUpperCase()} - {selectedFlat.priceEndRange?.toUpperCase()}</p> */}
        <p><strong>Size&nbsp;:&nbsp;  </strong> {selectedFlat.sqFeet} SQFT</p>
        
        <p><strong>Bedrooms&nbsp;:&nbsp;</strong> {selectedFlat.bedrooms?.toUpperCase()}</p>
        <p><strong>Furnishing&nbsp;:&nbsp;</strong> {selectedFlat.furnishingType?.toUpperCase()}</p>
        <p><strong>Facing&nbsp;:&nbsp;</strong> {selectedFlat.facing?.toUpperCase()}</p>
        <p><strong>Unit Type&nbsp;:&nbsp;</strong> {selectedFlat.unitType?.toUpperCase()}</p>
        <p><strong>Premium Add-On&nbsp;:&nbsp;</strong> {selectedFlat.specialFeature?.toUpperCase()}</p>
        {/* <p><strong>Construction Status&nbsp;:&nbsp;</strong> {selectedFlat.constructionStatus?.toUpperCase()}</p> */}
        <p><strong>Block&nbsp;:&nbsp;</strong> {selectedFlat.blockName?.toUpperCase()} |&nbsp; <strong>Floor&nbsp;:&nbsp;</strong> {selectedFlat.floor}</p>
        {/* <p><strong>Parking&nbsp;:&nbsp;</strong> {selectedFlat.parkingSlot?.toUpperCase()}</p> */}
        {/* <p><strong>Vasthu&nbsp;:&nbsp;</strong> {selectedFlat.vasthu?.toUpperCase()}</p> */}
      </div>
      {/* Show buttons only if the flat is available (isAvaliable is "AVALIABLE") */}
      {selectedFlat.isAvaliable === "AVALIABLE" && (
        <div className="flat-action-buttons">
          <button className="action-button create-estimation" onClick={openEstimationModal}>Create Estimation</button>
          <button className="action-button book-flat" onClick={handleBookFlat}>Book Flat</button>
        </div>
      )}
    </div>
  )}
</Modal>

            {/* Estimation Form Modal */}
         {/* Estimation Form Modal */}
{/* Estimation Form Modal */}
<Modal
  title="Create Estimation"
  open={isEstimationModalOpen}
  onCancel={closeEstimationModal}
  footer={null}
  width={1000}
  className="createestimation-modal"
>
  <div className="createestimation-form">
    {/* Form Fields Section */}
    <div className="createestimation-form-grid">
      {[
        { label: "Name", name: "name", placeholder: "Enter Name" },
        { label: "Tower Name", name: "towerName", placeholder: "Enter Tower Name", disabled: true },
        { label: "Phone", name: "phone", placeholder: "Enter Phone" },
        { label: "Country Code", name: "countryCode", placeholder: "Enter Country Code" },
        { label: "Email ID", name: "emailId", placeholder: "Enter Email" },
        { label: "Address", name: "address", placeholder: "Enter Address" },
        { label: "Pin Code", name: "pinCode", placeholder: "Enter Pin Code" },
        { label: "Flat No", name: "flatNo", placeholder: "Enter Flat No", disabled: true },
        { label: "Block No", name: "blockNo", placeholder: "Enter Block No", disabled: true },
        { label: "bedrooms", name: "bedrooms", placeholder: "Enter bedrooms", disabled: true },
        { label: "Square Feet", name: "sqFeet", placeholder: "Enter Square Feet", disabled: true },
        { label: "Unit Type", name: "unitType", placeholder: "Enter Unit Type", disabled: true },
        { label: "Square Feet Amount", name: "sqPrice", placeholder: "Enter Price per Sq Ft", disabled: true },
        { label: "Premium Add-On", name: "specialFeature", placeholder: "Enter Special Feature", disabled: true },
        { label: "Premium Add-On Price", name: "specialFeaturePrice", placeholder: "Enter Special Feature Price", disabled: true },
        { label: "Total Amount", name: "totalAmount", placeholder: "Enter Total Amount", disabled: true },
        { label: "Parking Charges", name: "parkingCharges", placeholder: "0", defaultValue: 0},
        { label: "Parking Slot", name: "parkingSlot", placeholder: "NA", defaultValue: "NA"},
        { label: "Remarks", name: "remarks", placeholder: "Enter Remarks" },
      ].map((field) => (
        <div key={field.name} className="createestimation-form-field">
          <label className="createestimation-form-label">{field.label.toUpperCase()}:</label>
          <Input
            name={field.name}
            value={formData[field.name]}
            onChange={handleInputChange}
            placeholder={field.placeholder}
            className={`createestimation-form-input ${field.disabled ? "disabled-input" : ""}`}
            disabled={field.disabled || false}
          />
        </div>
      ))}

      {/* Final Square Price Field */}
     {/* Final Square Price Field */}
{/* <div className="createestimation-form-field">
  <label className="createestimation-form-label">FINAL SQUARE PRICE:</label>
  <Input
    name="finalSqPrice"
    value={formData.finalSqPrice || formData.sqPrice}  // ✅ Shows sqPrice by default, or user's updated value
    onChange={handleInputChange}
    placeholder={`Default: ${formData.sqPrice}`}
    className="createestimation-form-input"
  />
</div> */}


    </div>

    {/* Payment Calculation Display - MIDDLE SECTION */}
    {showPaymentCalculation && PaymentCalculation && PaymentCalculation.length > 0 && (
      <div className="estimationpayment-calculation-section">
        <h3 className="estimationpayment-title">Payment Calculation</h3>
        {PaymentCalculation.map((calculation, index) => (
          <div key={index} className="estimationpayment-calculation-card">
            
            {/* Final Amount Display */}
            <div className="estimationpayment-final-amount">
              <strong>Total Final Amount: ₹{calculation.finalAmount?.toLocaleString()}</strong>
            </div>
            
            {/* Payment Scheme Table */}
            <div className="estimationpayment-scheme">
              <h4 className="estimationpayment-scheme-title">Payment Scheme Details:</h4>
              
              <table className="estimationpayment-table">
                <thead>
                  <tr className="estimationpayment-table-header">
                    <th className="estimationpayment-th">Percentage</th>
                    <th className="estimationpayment-th">Amount</th>
                    <th className="estimationpayment-th">Days</th>
                    <th className="estimationpayment-th">Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  {calculation.scheme?.map((payment, paymentIndex) => (
                    <tr key={paymentIndex} className="estimationpayment-table-row">
                      <td className="estimationpayment-td estimationpayment-percent">
                        {payment.percent}%
                      </td>
                      <td className="estimationpayment-td estimationpayment-amount">
                        ₹{payment.amount?.toLocaleString()}
                      </td>
                      <td className="estimationpayment-td estimationpayment-days">
                        {payment.days} days
                      </td>
                      <td className="estimationpayment-td estimationpayment-due-date">
                        {new Date(payment.dueDate).toLocaleDateString('en-IN')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    )}

    {/* Buttons Section - BOTTOM */}
    <div className="createestimation-form-buttons">
      <Button
        type="default"
        className="createestimation-submit-button"
        onClick={handleCheckEstimation}
      >
        Check Estimation
      </Button>
      
      <Button
        type="primary"
        className="createestimation-submit-button"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </div>
  </div>
</Modal>






          </>
        ) : (
          <p className="no-flats">No flats available for this tower.</p>
        )}
      </div>
    </>
  );
};

export default Flatdetails;
